import React, { Component } from 'react';
import './zipupload.css';
import {  Dropdown, Modal, Input, TextArea, Confirm, Label, Transition, Checkbox } from 'semantic-ui-react'
import { Button } from 'antd';
import axios from 'axios'
import 'react-virtualized/styles.css';

const fillDownOptions = [
  {value: 'shirttype_id', text: 'Shirt Type'},
  {value: 'fittype', text: 'Fit Type'},
  {value: 'colors', text: 'Colors'},
  {value: 'listprice', text: 'List Price'},
  {value: 'feature1', text: 'Feature 1'},
  {value: 'feature2', text: 'Feature 2'},
  {value: 'description', text: 'Description'},
  {value: 'merchtemplatetheme_id', text: 'Template Theme'},
  {value: 'merchcalendar_id', text: 'Event'},
  {value: 'merchdesigner_id', text: 'Designer'}
]

class ZipTableModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirmBox: false,
      dataInsideModal: props.dataInsideModal,
      fillDownSelection: '',
      openConfirmBoxFillDown: false
    }

    this.openCloseConfirm = this.openCloseConfirm.bind(this)
    this.saveEditedFields = this.saveEditedFields.bind(this)
    this.fillZipDataDown = this.fillZipDataDown.bind(this)
    this.openCloseConfirmFillDown = this.openCloseConfirmFillDown.bind(this)
    this.applyFillDown = this.applyFillDown.bind(this)
  }

  openCloseConfirm(){
    if (this.state.openConfirmBox === false) {
      this.setState({openConfirmBox: true})
    } else {this.setState({openConfirmBox: false})}
  }

  openCloseConfirmFillDown(){
    if (this.state.openConfirmBoxFillDown === false) {
      this.setState({openConfirmBoxFillDown: true})
    } else {this.setState({openConfirmBoxFillDown: false})}
  }

  updateInputBoxes(arrId, {...props}, e) {
    if (e.id !== '') {
      var switchID = e.id
      var switchValue = e.value
    } else { 
      var switchID = {...props}.target.id //eslint-disable-line
      var switchValue = {...props}.target.value //eslint-disable-line
    } 
    
    let index = switchID.indexOf("Field");
    let id = (switchID.substring(0, index));
    var arrayvar = this.state.currentSelectedZipFileQueue.slice()
    arrayvar[arrId - 1][id] = switchValue
    var newZipQueue = this.state.currentSelectedZipFileQueue[arrId - 1]
    newZipQueue[id] = switchValue
    this.setState({currentSelectedZipFileQueue: arrayvar});

  }

  changeDescription(e, {...props}) {
    var switchID
    var switchValue
    var errors = 0
    var dataInsideModal = this.state.dataInsideModal

    if(e.target.id !== "") {

      switchID = e.target.id
      switchValue = e.target.value
      if (switchID === 'uploadIndField') {
        if (switchValue !== '0' && switchValue !== '1') {
          alert("Upload Indicator can only by 1 or 0!");
          errors = 1
        }
      }

      if (errors === 0) {
        let index = switchID.indexOf("Field");
        let id = (switchID.substring(0, index));
        dataInsideModal[id] = switchValue
        
      }

    } else {

      switchID = {...props}.id
      switchValue = {...props}.value

      console.log({...props})

      if (switchID === "shirttype_idField") {
        for (var i = 0; i < this.props.fullProductTypes.length; i++) {
          if(this.props.fullProductTypes[i].id === switchValue) {
            dataInsideModal.listprice = this.props.fullProductTypes[i].listprice
          }
        }
      }

      if (switchID === "upload_indField") {
        if ({...props}.checked === true) {
          switchValue = 1
        } else {
          switchValue = 0
        }
      }

      let index = switchID.indexOf("Field");
      let id2 = (switchID.substring(0, index));
      dataInsideModal[id2] = switchValue
    }    

    //console.log(dataInsideModal)
    this.setState({dataInsideModal: dataInsideModal});
    
  }

  updateCurZipLoader(e, {...props}) {
    this.updateCurZip({...props}.value)
    this.setState({currentSelectedZip: {...props}.value})
  }

  async saveEditedFields() {

    //console.log(this.state.dataInsideModal)
    if (this.state.dataInsideModal.zipfile === undefined){
      var buildMultiInsertObject = {id: this.state.dataInsideModal.id, title: this.state.dataInsideModal.title, shirttype_id: this.state.dataInsideModal.shirttype_id
        ,fittype: this.state.dataInsideModal.fittype, colors: this.state.dataInsideModal.colors, listprice: this.state.dataInsideModal.listprice
        ,feature1: this.state.dataInsideModal.feature1, feature2: this.state.dataInsideModal.feature2, merchtemplatetheme_id: this.state.dataInsideModal.merchtemplatetheme_id
        ,merchcalendar_id: this.state.dataInsideModal.merchcalendar_id, merchdesigner_id: this.state.dataInsideModal.merchdesigner_id
        ,description: this.state.dataInsideModal.description}

      await axios.post('/api/updateIndividualZipContents', {
        buildInsertObject: buildMultiInsertObject
      })

      .then(function(results) { //eslint-disable-line
        if (results.data === "failed") {
          alert("Zip file failed to insert into the database...\nTry again later...")
        }
        //console.log(results);
      }) 
    } else { //eslint-disable-next-line
      var buildMultiInsertObject = {id: this.state.dataInsideModal.id, zipfile: this.state.dataInsideModal.zipfile, shirttype_id: this.state.dataInsideModal.shirttype_id
        ,fittype: this.state.dataInsideModal.fittype, colors: this.state.dataInsideModal.colors, listprice: this.state.dataInsideModal.listprice
        ,feature1: this.state.dataInsideModal.feature1, feature2: this.state.dataInsideModal.feature2, merchtemplatetheme_id: this.state.dataInsideModal.merchtemplatetheme_id
        ,merchcalendar_id: this.state.dataInsideModal.merchcalendar_id, merchdesigner_id: this.state.dataInsideModal.merchdesigner_id
        ,description: this.state.dataInsideModal.description, upload_ind: this.state.dataInsideModal.upload_ind}

      await axios.post('/api/updateIndividualZipFiles', {
        buildInsertObject: buildMultiInsertObject
      })

      .then(function(results) { //eslint-disable-line
        if (results.data === "failed") {
          alert("Zip file failed to insert into the database...\nTry again later...")
        }
        //console.log(results);
      })

      this.props.updateCurZip(buildMultiInsertObject.id) 
    }


    this.openCloseConfirm()
    this.props.closeEditModal()
  }

  applyFillDown(){
    this.openCloseConfirmFillDown()
    this.props.applyFillDown(this.state.fillDownSelection)
  }

  fillZipDataDown(e, {...props}) {
    this.setState({fillDownSelection: {...props}.value})
  }

  render() {
    const { dataInsideModal, fillDownSelection} = this.state

    if(dataInsideModal.zipfile !== undefined) {
      var titleOrZip = <div className="zipModalDescription">
          <Checkbox id="upload_indField" toggle label="Ready for upload?" checked={dataInsideModal.upload_ind} onChange={this.changeDescription.bind(this)} />
        </div>;
      var fillDownStuff = <div style={{fontWeight: '300', float: 'right', top: '-5px', position: 'relative'}}>Choose field to fill down:
          <Dropdown style={{fontSize: '14px', paddingLeft: '10px'}} options={fillDownOptions} selection onChange={this.fillZipDataDown.bind(this)} />
          <Button style={{marginLeft: '5px'}} onClick={this.openCloseConfirmFillDown} >Apply</Button>
          </div>;
      var confirmBoxRenderText = ('Are you sure you want to copy ' + fillDownSelection + ' to everything? There is no going back!')

    } else { 
      //eslint-disable-next-line
      var titleOrZip = <div className="zipModalDescription">Title: 
          <Input 
            id="titleField"
            value={dataInsideModal.title} 
            style={{width: '300px'}}
            onChange={this.changeDescription.bind(this)}
          />
        </div>;
      var fillDownStuff; //eslint-disable-line
    }

    return (
      <div>
        <Transition transitionOnMount={true} animation={'fade'}>
        <Modal open={this.props.showModal} dimmer={false}>
          <Modal.Header>Edit row: {dataInsideModal.id} {fillDownStuff}</Modal.Header>
          <Modal.Content scrolling>
            <Modal.Description>
              {titleOrZip}

              <div className="zipModalDescription">Shirt Type: 
                <Dropdown 
                  id="shirttype_idField" 
                  selection 
                  value={dataInsideModal.shirttype_id} 
                  options={this.props.productTypeOptions} 
                  onChange={this.changeDescription.bind(this)}
                />
              </div>

              <div className="zipModalDescription">Fit Type: 
                <Input 
                  id="fittypeField"
                  value={dataInsideModal.fittype} 
                  style={{width: '300px'}}
                  onChange={this.changeDescription.bind(this)}
                />
              </div>

              <div className="zipModalDescription">Colors: 
                <Input 
                  id="colorsField" 
                  placeholder="green,blue" 
                  value={dataInsideModal.colors} 
                  onChange={this.changeDescription.bind(this)}
                />
              </div>

              <div className="zipModalDescription">List Price: 
                <Input 
                  id="listpriceField" 
                  labelPosition='left' 
                  type='text' 
                  value={dataInsideModal.listprice} 
                  onChange={this.changeDescription.bind(this)}>
                  <Label basic style={{background: '#9DFA9D'}}>$</Label>
                  <input />
                </Input>
              </div>

              <div className="zipModalDescription">Feature 1: 
                <Input 
                  id="feature1Field" 
                  placeholder="feature..." 
                  value={dataInsideModal.feature1}
                  style={{width: '300px'}}
                  onChange={this.changeDescription.bind(this)} 
                />
              </div>

              <div className="zipModalDescription">Feature 2: 
                <Input 
                  id="feature2Field" 
                  placeholder="feature..." 
                  value={dataInsideModal.feature2}
                  style={{width: '300px'}}
                  onChange={this.changeDescription.bind(this)} 
                />
              </div>

              <div className="zipModalDescription">Description: 
                <TextArea 
                  id="descriptionField" 
                  autoHeight 
                  style={{'width': '85%', 'verticalAlign': 'top', 'marginLeft': '5px'}} 
                  value={dataInsideModal.description} 
                  onChange={this.changeDescription.bind(this)} 
                />
              </div> 

              <div className="zipModalDescription">Template Theme: 
                <Dropdown
                  id="merchtemplatetheme_idField"  
                  search
                  selection 
                  placeholder='Template Theme...' 
                  value={dataInsideModal.merchtemplatetheme_id} 
                  options={this.props.templateThemeOptions} 
                  onChange={this.changeDescription.bind(this)}
                />
              </div>

              <div className="zipModalDescription">Event: 
                <Dropdown
                  id="merchcalendar_idField" 
                  search 
                  selection 
                  placeholder='Event...' 
                  value={dataInsideModal.merchcalendar_id} 
                  options={this.props.eventOptions} 
                  onChange={this.changeDescription.bind(this)}
                />
              </div>

              <div className="zipModalDescription">Designer: 
                <Dropdown 
                  id="merchdesigner_idField"
                  selection 
                  placeholder='Designer...' 
                  value={dataInsideModal.merchdesigner_id} 
                  options={this.props.designerOptions}
                  onChange={this.changeDescription.bind(this)}
                />
              </div>

            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.props.closeEditModal} style={{marginRight: 8}}>
              Cancel
            </Button>
            <Button type="primary" onClick={this.openCloseConfirm}>
              Save
            </Button>
          </Modal.Actions>
        </Modal>
        </Transition>
        <Transition visible={this.state.openConfirmBox} animation={'fade'}>
        <Confirm open={this.state.openConfirmBox}
          content='Are you sure you want to save your changes? There is no going back!' 
          onCancel={this.openCloseConfirm}
          onConfirm={this.saveEditedFields} dimmer={false}/>
        </Transition>
        <Transition visible={this.state.openConfirmBoxFillDown} animation={'fade'}>
        <Confirm open={this.state.openConfirmBoxFillDown}
          content={confirmBoxRenderText}
          onCancel={this.openCloseConfirmFillDown}
          onConfirm={this.applyFillDown} dimmer={false}/>
        </Transition>
      </div>
    );
  }
}

export default ZipTableModal;




// WEBPACK FOOTER //
// ./src/pages/ZipTableModal.js